export const isClearResponse = message => {
  return typeof message.id === 'number' && typeof message.result === 'boolean';
};
